import React from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Stack } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/hooks';
import { updateTeam } from '../../../state';
import { useTeamFormValidation } from '../../../hooks';

/**
 * TeamFormFields - Component for team name, description, and status fields
 */
export const TeamFormFields: React.FC = () => {
  const dispatch = useAppDispatch();
  const formData = useAppSelector(state => state.team.currentTeam);
  
  // Use validation hook
  const { getFieldError, hasFieldError, touchField } = useTeamFormValidation(formData);

  const handleInputChange = (field: string) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    dispatch(updateTeam({ [field]: event.target.value }));
  };

  const handleStatusChange = (event: any) => {
    dispatch(updateTeam({ status: event.target.value }));
  };

  return (
    <Stack spacing={2}>
      <TextField
        label="Team Name *"
        size="small"
        fullWidth
        value={formData?.name || ''}
        onChange={handleInputChange('name')}
        onBlur={() => touchField('name')}
        placeholder="Enter team name"
        error={hasFieldError('name')}
        helperText={getFieldError('name')}
      />
      
      <TextField
        label="Description *"
        size="small"
        multiline
        rows={3}
        fullWidth
        value={formData?.description || ''}
        onChange={handleInputChange('description')}
        onBlur={() => touchField('description')}
        placeholder="Describe the team's purpose and responsibilities"
        error={hasFieldError('description')}
        helperText={getFieldError('description')}
        InputProps={{
          sx: {
            alignItems: 'flex-start',
            '& .MuiInputBase-input': {
              paddingTop: '8px',
            }
          }
        }}
      />
      
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel>Status</InputLabel>
        <Select
          value={formData?.status || 'ACTIVE'}
          onChange={handleStatusChange}
          label="Status"
        >
          <MenuItem value="ACTIVE">Active</MenuItem>
          <MenuItem value="INACTIVE">Inactive</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
};

export default TeamFormFields;